import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { BaseXYAxisChartOptions, MetaInfoOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { HyperSpaceColumnChartWidgetOptions } from './types';
import { observable } from 'mobx';

export class HyperSpaceColumnChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceColumnChartWidgetOptions {
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        overflow: true,
        grid: {
            enabled: false,
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
            label: {
                enabled: true,
                size: 50,
            },
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
            label: {
                enabled: true,
                size: 50,
            },
        },
    };
    @observable metaInfoOptions: MetaInfoOptions = {
        color: {
            enabled: false,
            type: 'fill',
        },
        image: {
            enabled: false,
        },
    };
    @observable columnWidth = 90;
}
